import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { Constant } from 'app/config/constants';
import { DialogService } from 'app/service/dialog.service';
import { CommonTableService } from 'app/service/common-table.service';
import { CommonTable } from 'app/model/entity/commonTable';

@Component({
  selector: 'app-dialog-setting-route-display',
  templateUrl: './dialog-setting-route-display.component.html',
  styleUrls: ['./dialog-setting-route-display.component.scss']
})
export class DialogSettingRouteDisplayComponent implements OnInit {
  Constant = Constant;
  /**
   * commonTable
   */
  commonTable: CommonTable;

  /**
   * true if set eoute/stop to be displayed
   */
  isDisplayRoute: Boolean;

  constructor(
    private dialogRef: MatDialogRef<DialogSettingRouteDisplayComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private changeDetectorRef: ChangeDetectorRef,
    private commonTableService: CommonTableService,
    private dialogService: DialogService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.commonTable = this.data.commonTable;
    this.isDisplayRoute = this.commonTable.value === Constant.BOOLEAN_STRING.TRUE;
    this.changeDetectorRef.detectChanges();
  }

  /**
   * toggle route stop
   */
  toggleRouteStop(): void {
    this.isDisplayRoute = !this.isDisplayRoute;
  }

  /**
   * save
   * @returns
   */
  save(): void {
    this.commonTable.value = this.isDisplayRoute ? Constant.BOOLEAN_STRING.TRUE : Constant.BOOLEAN_STRING.FALSE;
    this.commonTableService.save(this.commonTable).subscribe(
      () => {
        this.dialogRef.close({ isDisplayRoute: this.isDisplayRoute });
      },
      error => Helper.handleError(error, this.translateService, this.dialogService)
    );
  }

  /**
   * close dialog
   */
  public closeDialog(): void {
    this.dialogRef.close({});
  }
}
export interface DialogData {
  commonTable: CommonTable;
}
